import { render, staticRenderFns } from "./CheckList.vue?vue&type=template&id=6d7fe73b&scoped=true&class=justify-center"
import script from "./CheckList.vue?vue&type=script&lang=js"
export * from "./CheckList.vue?vue&type=script&lang=js"
import style0 from "./CheckList.vue?vue&type=style&index=0&id=6d7fe73b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7fe73b",
  null
  
)

export default component.exports